import { render, staticRenderFns } from "./HomeOrders.vue?vue&type=template&id=603a544e&scoped=true"
import script from "./HomeOrders.vue?vue&type=script&lang=js"
export * from "./HomeOrders.vue?vue&type=script&lang=js"
import style0 from "./HomeOrders.vue?vue&type=style&index=0&id=603a544e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603a544e",
  null
  
)

export default component.exports